/**
 * UI strings for living drawings + the first-2-minutes drawing (liv.*). `vi` must cover every `en` key.
 */
export const en = {
  'liv.scan.title': 'A little magic…',
  'liv.scan.line': 'Lifting your drawing off the paper',
  'liv.alive.title': "It's alive!",
  'liv.alive.meet': 'Meet {creature}!',
  'liv.tapMe': 'Tap me!',
  'liv.saved': 'Saved to your creature book',
  'liv.praise.1': '{name}, look! Your drawing came alive! Say hi to {creature}!',
  'liv.praise.2': 'Wow, {name}! You made {creature} with your own pencil. Tap it to play!',
  'liv.praise.3': 'Amazing work, {name}! {creature} wants to be your friend!',
  'liv.noDrawing': "I couldn't see your drawing clearly, {name}, but I love that you tried! It's in your journal.",
  'liv.polaroidHint': 'Tap {creature}!',
  'liv.first.title': "Let's draw your first friend, {name}!",
  'liv.first.sub': 'Grab a pencil and any paper. It takes one minute!',
  'liv.first.step1': 'A big round bean',
  'liv.first.step2': 'Two dots for eyes',
  'liv.first.step3': 'A happy smile',
  'liv.first.step4': 'Two little feet',
  'liv.first.say': "{name}, let's draw your very first friend! Watch me, then draw it on your paper.",
  'liv.first.sayDone': 'Now your turn! When you are done, take a photo and watch the magic.',
  'liv.first.done': 'I drew it!',
  'liv.first.later': 'Not now',
  'liv.first.replay': 'Watch again',
  'liv.first.noPaper': 'No paper? You can draw on the screen too.',
  'liv.first.yourTurn': 'Your turn!',
  'liv.first.journalTitle': 'My first friend',
};

export const vi: Record<keyof typeof en, string> = {
  'liv.scan.title': 'Một chút phép thuật…',
  'liv.scan.line': 'Đang nhấc tranh của con ra khỏi tờ giấy',
  'liv.alive.title': 'Tranh sống dậy rồi!',
  'liv.alive.meet': 'Đây là {creature}!',
  'liv.tapMe': 'Chạm vào tớ đi!',
  'liv.saved': 'Đã cất vào sổ sinh vật của con',
  'liv.praise.1': '{name} ơi, nhìn kìa! Tranh của con sống dậy rồi! Chào {creature} đi nào!',
  'liv.praise.2': 'Oa, {name}! Con tự tay vẽ ra {creature} đó. Chạm vào để chơi nhé!',
  'liv.praise.3': 'Giỏi quá {name} ơi! {creature} muốn làm bạn với con đấy!',
  'liv.noDrawing': 'Cô chưa nhìn rõ tranh lắm, {name} ơi, nhưng cô rất vui vì con đã thử! Tranh đã vào nhật ký rồi.',
  'liv.polaroidHint': 'Chạm vào {creature}!',
  'liv.first.title': 'Mình cùng vẽ người bạn đầu tiên nhé, {name}!',
  'liv.first.sub': 'Lấy bút chì và một tờ giấy bất kỳ. Chỉ mất một phút thôi!',
  'liv.first.step1': 'Một hạt đậu tròn to',
  'liv.first.step2': 'Hai chấm làm mắt',
  'liv.first.step3': 'Một nụ cười thật tươi',
  'liv.first.step4': 'Hai bàn chân nhỏ xíu',
  'liv.first.say': '{name} ơi, mình cùng vẽ người bạn đầu tiên nhé! Con xem cô vẽ trước, rồi vẽ lên giấy của con.',
  'liv.first.sayDone': 'Đến lượt con rồi! Vẽ xong thì chụp ảnh lại và xem phép thuật nhé.',
  'liv.first.done': 'Con vẽ xong rồi!',
  'liv.first.later': 'Để sau',
  'liv.first.replay': 'Xem lại',
  'liv.first.noPaper': 'Không có giấy? Con có thể vẽ ngay trên màn hình.',
  'liv.first.yourTurn': 'Đến lượt con!',
  'liv.first.journalTitle': 'Người bạn đầu tiên của con',
};
